import { render, staticRenderFns } from "./BowMenu.vue?vue&type=template&id=225fc70e&"
import script from "./BowMenu.vue?vue&type=script&lang=js&"
export * from "./BowMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowMenuLink: require('/workspace/components/atoms/BowMenuLink/BowMenuLink.vue').default})
